import { compactStringRef } from '@agilelab/plugin-wb-platform-common';
import { z } from 'zod';

export const accessRequestNotificationRequestDataZod = z.object({
  requester: z.preprocess(
    value => compactStringRef(value as string),
    z.string().regex(new RegExp('^user:.+$')),
  ),
  requester_display_name: z.string(),
  id_dataproduct_instance: z.number(),
  id_output_port: z.number(),
  environment: z.string(),
  identities: z.string().array(),
  requestsManagementUrl: z.string().optional(),
  dataproduct: z.object({
    id: z.number(),
    name: z.string(),
    display_name: z.string().optional(),
    domain: z.string(),
    version: z.string(),
    data_product_owner: z.string(),
    data_product_display_name: z.string(),
    external_id: z.string(),
  }),
  outputport: z.object({
    name: z.string(),
    output_port_type: z.string(),
    external_id: z.string(),
  }),
  verb: z.union([z.literal('grant'), z.literal('revoke')]),
  displayFields: z.array(z.any()),
});

export type AccessRequestNotificationRequestData = z.infer<
  typeof accessRequestNotificationRequestDataZod
>;
